const setCurrentTokenValue = ({ commit }, payload) => {
  commit('setCurrentTokenValue', payload)
}

export default {
  setCurrentTokenValue,
}
